import * as React from 'react';
import { useEffect } from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { content } from '../utils/data';



function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}



function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, header } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (

        <TableHead sx={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff', // Important! Prevents transparent sticky header
            zIndex: 1,

        }}>
            <TableRow>
                {header.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding="normal"
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{
                            width: headCell.width,
                            border: '1px solid #ccc',
                            textAlign: 'center',
                            fontWeight: 'bold', width: headCell.width


                        }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}



export default function EnhancedTable({ rows, header, height = "400px", verticalAlign = "center" }) {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to first page when rows per page is changed
    };

    const visibleRows = React.useMemo(
        () =>
            [...rows]
                .sort(getComparator(order, orderBy))
                .slice(page * rowsPerPage, (page + 1) * rowsPerPage), // Corrected slicing logic
        [rows, order, orderBy, page, rowsPerPage]
    );

    useEffect(() => {
        setPage(0);
    }, [rows]);

    return (
        <div className='w-full'>
            <Box >
                <Paper sx={{
                    borderRadius: 2,
                    overflow: 'hidden',
                    border: '1px solid #ccc',
                }}>
                    <TableContainer sx={{
                        textAlign: 'left',
                        height: height,
                        overflow: 'scroll'

                    }}>
                        <Table aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                header={header} // Ensure header is passed here
                            />

                            <TableBody>
                                {visibleRows.map((row, index) => (
                                    <TableRow hover tabIndex={-1} key={index}>
                                        {header.map((headCell) => (
                                            <TableCell
                                                key={headCell.id}
                                                sx={{
                                                    border: '1px solid #ccc',
                                                    textAlign: headCell.numeric ? 'right' : 'left', // Use the alignment from the header
                                                    verticalAlign: verticalAlign, // add this
                                                }}
                                            >
                                                {/* Dynamically render the value based on the column id */}
                                                {row[headCell.id] ?? ''}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>


                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Box>
        </div>
    );
}
